import { useEffect } from 'react'

/**
 * Prevents the browser from interpreting touch-move as native scroll while a drag is active.
 *
 * Why: On mobile (notably Android Chrome), native scroll can steal the gesture mid-drag,
 * triggering touchcancel / pointercancel and causing dnd-kit to cancel and “snap back”.
 *
 * This is intentionally scoped to the drag window only, so normal scrolling works when
 * not dragging.
 */
export function usePreventTouchScrollWhileDragging(isDragging: boolean) {
  useEffect(() => {
    if (!isDragging) return

    const handleTouchMove = (e: TouchEvent) => {
      // Allow pinch-zoom and other multi-touch gestures.
      if (e.touches && e.touches.length > 1) return
      if (!e.cancelable) return
      e.preventDefault()
    }

    // Must be non-passive for preventDefault() to work.
    document.addEventListener('touchmove', handleTouchMove, { passive: false })
    return () => {
      document.removeEventListener('touchmove', handleTouchMove)
    }
  }, [isDragging])
}
